import React from 'react'
import { Link } from 'react-router-dom'
import { Box, Button, Grid, Typography } from '@the-platform-group/component-library'
import { Add as AddIcon } from '@the-platform-group/component-library/Icons'

import Spinner from 'components/Spinner'
import { ListPaper } from 'components/Paper'

import PromptFilters from './components/PromptFilters'
import PromptsTable from './components/PromptsTable'
import { useAgenticPrompts } from './hooks/useAgenticPrompts'
import { useDeleteAgenticPrompt } from './hooks/useDeleteAgenticPrompt'
import { useReorderAgenticPrompts } from './hooks/useReorderAgenticPrompts'

const AgenticPromptsList = () => {
  const {
    prompts,
    filters,
    apiFilters,
    isPending,
    handleSearch,
    handleWorkflowsChange,
    handleCategoriesChange,
    handleStatusesChange,
  } = useAgenticPrompts()
  const { deletePrompt } = useDeleteAgenticPrompt()
  const { mutate: reorderPrompts } = useReorderAgenticPrompts(apiFilters)

  const handleRowOrderChange = visibleRowIds => {
    reorderPrompts({ visibleRowIds })
  }

  return (
    <>
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
        <Typography variant="h3">AI Prompts</Typography>
        <Button component={Link} to="/ai-prompts/new" variant="contained" startIcon={<AddIcon />}>
          New prompt
        </Button>
      </Box>

      <Grid container direction="column" spacing={2}>
        <Grid item>
          <PromptFilters
            filters={filters}
            onSearch={handleSearch}
            onWorkflowsChange={handleWorkflowsChange}
            onCategoriesChange={handleCategoriesChange}
            onStatusesChange={handleStatusesChange}
          />
        </Grid>

        {isPending && !prompts.length ? (
          <Spinner />
        ) : (
          <Grid item>
            <ListPaper>
              <PromptsTable
                prompts={prompts}
                isLoading={isPending}
                onDelete={deletePrompt}
                onRowOrderChange={filters.term ? undefined : handleRowOrderChange}
              />
            </ListPaper>
          </Grid>
        )}
      </Grid>
    </>
  )
}

export default AgenticPromptsList
